module.exports = {
$authorizeFromStudentToSuperAdmin : ['student','teacher','campusadmin','schooladmin','super-admin'],
$authorizeFromTeacherToSuperAdmin : ['teacher','campusadmin','schooladmin','super-admin'],
$authorizeFromCampusAdminToSuperAdmin : ['campusadmin','schooladmin','super-admin'],
$authorizeFromSchoolAdminToSuperAdmin : ['schooladmin','super-admin'],
$authorizeToSuperAdmin : ['super-admin'],
  };